
export default function TakeRide(){


return(
    <>
    <div className="takeRideMainDiv">
        <div className="takeRideImageBox">
            <img src="./takeRide.png" alt="image1" />
        </div>
    </div>





    </>
)

}